import React from 'react'
import { Provider, useSelector } from 'react-redux'
import { Tooltip } from '@mui/material'
import { IconButton } from '@mui/material'
import { FilterAlt } from '@mui/icons-material'
import BaseMapControl from './BaseMapControl'

/**
 * Control de filtros que se integra nativamente con Mapbox
 * El botón dispara un callback, el Popover se renderiza en el componente principal
 */
class FilterControl extends BaseMapControl {
  constructor(store, theme, onToggle, alertRef) {
    super({ className: 'filter-control' })
    this.store = store
    this.theme = theme
    this.onToggle = onToggle
    this.alertRef = alertRef
  }

  _renderContent() {
    const FilterButton = () => {
      const [isHovered, setIsHovered] = React.useState(false)

      const filterPopoverOpen = useSelector(state => state.ui?.filterPopoverOpen || false)
      const hasTreeData = useSelector(state => (state.treeFeatures.data?.features?.length ?? 0) > 0)

      const handleClick = e => {
        this.onToggle(e.currentTarget)
      }

      const buttonStyles = {
        minWidth: '30px',
        width: '30px',
        height: '30px',
        padding: 0,
        margin: 0,
        color:
          filterPopoverOpen || isHovered
            ? this.theme.palette.text.white
            : this.theme.palette.text.primary,
        bgcolor:
          filterPopoverOpen || isHovered
            ? this.theme.palette.secondary.main
            : this.theme.palette.text.white,
        border: 'none',
        '&:hover': {
          bgcolor: this.theme.palette.secondary.main,
          color: this.theme.palette.primary.main,
        },
      }

      return (
        <Tooltip title={hasTreeData ? 'Filtros' : 'Sin datos para filtrar'} placement="right">
          <span>
            <IconButton
              onClick={handleClick}
              size="small"
              sx={buttonStyles}
              disabled={!hasTreeData}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}>
              <FilterAlt fontSize="small" />
            </IconButton>
          </span>
        </Tooltip>
      )
    }

    this._root.render(
      <Provider store={this.store}>
        <FilterButton />
      </Provider>
    )
  }
}

export default FilterControl
